import { Modal } from 'almanac-ui/Modal'

interface Props {
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmationModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <Modal.Root onPressOutside={() => {}}>
      <Modal.Header title="Are you sure?" subHeader="You will lose all changes." isConfirmation />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="secondary" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onConfirm}>Confirm</Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
